import { Regions } from '@wicadu/langscope'

import globalTranslations from '@translations/pages/contact-us/global'

export const CONTACT_US_TRANSLATIONS = {
  [Regions.Global]: globalTranslations,
} as const
